module.exports = "<!-- <p>\n  form-h1 works!\n</p>\n -->\n<div class=\"form-group\">\n    <label>\n    \t<!-- <ng-content></ng-content> -->\n        <!-- <input [(ngModel)]=\"value\"\n                class=\"form-control\"\n                (blur)=\"onBlur()\" > -->\n\t\t<h1 [(ngModel)]=\"value\" class=\"form-control\" (blur)=\"onBlur()\" ngDefaultControl tabindex=\"0\">{{value || placeholder}}</h1>\n    </label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/form-h1/form-h1.component.html
// module id = ./src/app/form-h1/form-h1.component.html
// module chunks = main